<template>
  <div class="order-buyer-detail">
    <NavTop title="订单详情" />
    <div class="status-con">
      <p class="title-status">{{ form.status | statusFilter }}</p>
      <div
        v-if="form.status == -1 || form.status == -2"
        style="padding: 20px 100px"
      >
        <van-button
          size="small"
          round
          block
          type="info"
          native-type="submit"
          @click="toGoodsDetail()"
          >再次购买</van-button
        >
      </div>
    </div>
    <div class="detail-con">
      <div class="title">订单信息</div>
      <p class="des-item">游戏区服：{{ form.gameServer }}</p>
      <p class="des-item">商品种类：角色</p>
      <p class="des-item">订单编号：{{ form.orderId }}</p>
      <p class="des-item">创建时间：{{ form.createTime }}</p>
      <p class="des-item">商品编号：{{ form.goodsId }}</p>
      <p class="des-item">商品角色名：{{ form.roleName }}</p>
      <p class="des-item">商品单价：￥{{ form.goodsAmount }}</p>
      <p class="des-item">商品数量：{{ form.goodsNum }}</p>
      <p class="des-item">总价(元)：￥{{ form.amount }}</p>
    </div>
  </div>
</template>
<script>
import NavTop from "@/components/nav-top/index.vue";
import { getOrderInfo } from "@/api/person";
export default {
  name: "OrderBuyerDeatil",
  components: { NavTop },
  filters: {
    statusFilter(num) {
      const statusMap = {
        "-2": "系统已取消",
        "-1": "订单已取消",
        0: "订单未支付",
        1: "订单已付款",
        2: "商品已发货",
        3: "订单已完成",
      };
      return statusMap[num];
    },
  },
  data() {
    return {
      form: {},
    };
  },
  mounted() {
    if (this.$route.query.orderId) {
      this.getOrderInfo();
    }
  },
  methods: {
    toGoodsDetail() {
      this.$router.push({
        path: "goods-detail" + this.toDetailPage(this.form.gameId),
        query: { goodsId: this.form.goodsId },
      });
    },
    getOrderInfo() {
      getOrderInfo(this.objToStr({ orderId: this.$route.query.orderId })).then(
        (res) => {
          this.form = res;
        }
      );
    },
  },
};
</script>
<style scoped>
.order-buyer-detail .top {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  background: #ebebeb;
  position: relative;
  text-align: center;
}
.order-buyer-detail .top .back {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 24px;
}
.order-buyer-detail .status-con {
  border: 1px solid #d7d7d7;
  margin: 12px;
  text-align: center;
  font-size: 14px;
}
.order-buyer-detail .detail-con {
  border: 1px solid #d7d7d7;
  margin: 12px;
}
.order-buyer-detail .status-con .title-status {
  font-size: 16px;
  color: #c40000;
  line-height: 40px;
}

.order-buyer-detail .title {
  border-bottom: 2px solid #dddddd;
  font-size: 14px;
  line-height: 30px;
  margin: 10px 14px 0 14px;
}

.order-buyer-detail .des {
  font-size: 12px;
  line-height: 20px;
  padding: 0 14px;
}
.order-buyer-detail .des-item {
  line-height: 26px;
  padding: 0 14px;
  font-size: 14px;
}
</style>